import { MemberTitle } from '../../../../../../../models/enums/MemberTitle';
import { getOptionsFromEnum } from '../../../../../../../utils/getOptionsFromEnum';

export enum MemberPersonalDetailsFormFields {
  Prefix = 'prefix',
  Phone = 'phone',
}

export const MemberTitleOptions = getOptionsFromEnum(MemberTitle);
